// extracted by mini-css-extract-plugin
export default {"sectionTitleContainer":"SectionTitle_sectionTitleContainer__qUnGE","sectionTitle":"SectionTitle_sectionTitle__NbQes"};